import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgGroupUpdateJoinContentProps } from './msg-group-update-join-content';
import { MsgGroupUpdateJoinContent } from './msg-group-update-join-content';

export interface MsgGroupUpdateJoinPreviewProps extends MsgGroupUpdateJoinContentProps {}

export const MsgGroupUpdateJoinPreview = memo(function MsgGroupUpdateJoinPreview({
  message,
}: MsgGroupUpdateJoinPreviewProps) {
  return (
    <LastMessageSystem>
      <MsgGroupUpdateJoinContent message={message} />
    </LastMessageSystem>
  );
});
